import { Injectable } from '@angular/core';
import { HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { StaticTokenHolderService } from '../../core/auth/static-token-holder.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class HostInterceptor implements HttpInterceptor {

  constructor(private staticTokenHolder: StaticTokenHolderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (req.url.includes('app.config.json')) {
      return next.handle(req);
    }

    const envToken = (environment as { staticToken?: string }).staticToken ?? '';
    let token = this.staticTokenHolder.getToken();
    if (!token) {
      token = envToken;
      if (token) {
        this.staticTokenHolder.setToken(token);
      }
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
      'X-Frame-Options': 'sameorigin',
      'X-XSS-Protection': '1',
      'Authorization': `Bearer ${token}`,
    });

    return next.handle(req.clone({ headers })).pipe(
      catchError(error => throwError(() => error))
    );
  }
}
